const Redirect = () => {
  window.location.replace(
    process.env.REACT_APP_sisUrl !== undefined ? process.env.REACT_APP_sisUrl : '',
  );
  return <>Redirecting...</>;
};

export default Redirect;
